import React from 'react';

const TextResponse = ({ question, response, onUpdate, isParagraph }) => {
  const handleChange = (e) => {
    onUpdate(question.id, e.target.value);
  };

  const minLen = question.config?.minLen || 1;
  const maxLen = question.config?.maxLen || (isParagraph ? 1000 : 100);
  const currentLength = response?.value?.length || 0;

  return (
    <div>
      {isParagraph ? (
        <textarea
          value={response?.value || ''}
          onChange={handleChange}
          placeholder="Your answer"
          rows={4}
          maxLength={maxLen}
          className="form-control"
        />
      ) : (
        <input
          type="text"
          value={response?.value || ''}
          onChange={handleChange}
          placeholder="Your answer"
          maxLength={maxLen}
          className="form-control"
        />
      )}

      <div className="d-flex justify-content-between align-items-center mt-1">
        <small className="text-muted">
          {currentLength}/{maxLen}
        </small>
        {question.config?.minLen && currentLength < minLen && (
          <small className="text-danger">
            Minimum {minLen} characters required
          </small>
        )}
      </div>
    </div>
  );
};

export default TextResponse;
